// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__CNUCX","consentsList":"PatientConsents_consentsList__uMdwD","consentsListEmpty":"PatientConsents_consentsListEmpty__sknzN"};